import { useEffect, useState } from 'react';

const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

interface IWidthLimits {
  lowerLimit?: number
  upperLimit?: number
}

interface IUseMediaQuery {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

const getWindowWidth = () => window.innerWidth;

const checkWidthLimits = (width: number, { lowerLimit, upperLimit }: IWidthLimits): boolean => {
  const isHigher = lowerLimit ? width > lowerLimit : true;
  const isLower = upperLimit ? width <= upperLimit : true;

  return isHigher && isLower;
};

const useMediaQuery = (): IUseMediaQuery => {
  const { md, lg } = breakpoints;

  const [width, setWidth] = useState(getWindowWidth());

  useEffect(() => {
    const listener = () => {
      setWidth(getWindowWidth());
    };

    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, [width]);

  return {
    isMobile: checkWidthLimits(width, { upperLimit: md }),
    isTablet: checkWidthLimits(width, { upperLimit: lg, lowerLimit: md }),
    isDesktop: checkWidthLimits(width, { lowerLimit: lg }),
  };
};

export default useMediaQuery;
